var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"t-map"},[_c('van-loading',{staticClass:"loading-center",attrs:{"loading-text":"加载中...","size":"50"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }